import type { FontId, FontLike } from "@memeup/design/browser";

const URLS: Record<FontId, string> = { anton: "/fonts/Anton-Regular.ttf" };
const cache = new Map<FontId, Promise<FontLike>>();

/** The exact font file the print renderer uses, so the preview is the print. */
export function loadMemeFont(id: FontId = "anton"): Promise<FontLike> {
  let p = cache.get(id);
  if (!p) {
    // The parser is only needed where memes are previewed: load it on demand.
    p = Promise.all([import("opentype.js"), fetch(URLS[id]).then((r) => r.arrayBuffer())]).then(
      ([ot, buf]) => ot.parse(buf) as unknown as FontLike,
    );
    cache.set(id, p);
  }
  return p;
}
